import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateOrder from "./OrderUpdate";
import OrderViews from "./OrderView";
import vAdminformat from '../../adminFormat';
import CustomDateRangePicker from "../CustomDateRangePicker";
import Swal from "sweetalert2";
import SimpleSTLViewer from '../Canvas/SimpleStlViewerGridOrder';
import JobLiveView from "../jobs/JobLiveView";
import Selecto from "react-selecto";
import getFileExtension from "../getFileExtension";


const server_backend = config.API_URL;

const Orders = ({ email }) => {
    const [OrderList, setOrderList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("fullname");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBOrder, setViewBOrder] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });
    const [isGridView, setIsGridView] = useState(false);
    const [jobList, setJobList] = useState([]);
    const [viewBJob, setViewBJob] = useState(false);
    const [currentJob, setCurrentJob] = useState(0);

    const [filtersEnabledJob, setFiltersEnabledJob] = useState(false);
    const [filterByJob, setFilterByJob] = useState("fullname");
    const [filterStatusJob, setFilterStatusJob] = useState(0);
    const [filterValueJob, setFilterValueJob] = useState(null);
    const [selectedFilterJob, setSelectedFilterJob] = useState("");
    const [statusJob, setStatusJob] = useState([]);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [addCollectiveModal, setAddCollectiveModal] = useState(false);
    const [collectiveList, setCollectiveList] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(0);
    const [showInProcess, setShowInProcess] = useState(false);
    const [cardSize, setCardSize] = useState("vs");

    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        const getOrders = async () => {
            try {
                const response = await axios.get(`${server_backend}/Orders/list`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    setOrderList(data.filter((element) => element.est_ID !== 11 && element.est_ID !== 9));
                }

            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getOrders();
    }, []);

    useEffect(() => {

        const getJobs = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);

                if (response.data.RES_CODE === "00") {
                    //This will filter only jobs in production exept complete ones

                    const filterJobs = response.data.RES_RESULT.filter((job) => {
                        return job.status_order !== 7 && job.colle_id === 0 && job.est_ID === 18;
                    }
                    );

                    setJobList(filterJobs);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }

        setTimeout(() => {
            getJobs();
        }, 500);

    }, [isGridView]);

    const getJobs = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);
            //console.log("Unexpected error, please check")



            if (response.data.RES_CODE === "00") {
                //This will filter only jobs in production exept complete ones



                const filterJobs = response.data.RES_RESULT.filter((job) => {
                    return job.status_order !== 7 && job.colle_id === 0;
                }
                );
                setJobList(filterJobs);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [selectedDayRange]);

    const getOrders = async () => {

        try {
            const response = await axios.get(`${server_backend}/Orders/list`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                if (showInProcess === false) {
                    setOrderList(data.filter((element) => element.est_ID !== 11 && element.est_ID !== 9));
                } else {
                    setOrderList(data.filter((element) => element.est_ID !== 11));
                }
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    useEffect(() => {
        const getStatusOrder = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Order`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusOrder();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Orders/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                setOrderList(data.filter((element) => element.est_ID !== 11 && element.est_ID !== 9));
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewOrder = () => {
        setViewBOrder(true);
    }

    const CloseViewOrder = () => {
        setViewBOrder(false);
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = OrderList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(OrderList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const handleDateChangeJob = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const handleUpdate = async (onOrderID) => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to cancel this Order?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/Orders/update`, {
                        id: onOrderID,
                        est_id: 11
                    }, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Canceled Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getOrders();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //console.log("Unexpected error, please check")







                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            }
        }
        )
    };

    const toggleView = () => {
        setIsGridView(!isGridView);
    };

    const showViewJob = () => {
        setViewBJob(true);
    }

    const CloseViewJob = () => {
        setViewBJob(false);
    }

    const handleFiltersToggleJob = () => {
        setFiltersEnabledJob(!filtersEnabled);
    };

    const handleFilterByChangeJob = (e) => {
        setFilterByJob(e.target.value);
        const value = e.target.value;

    };


    const handleFilterValueChangeJob = (e) => {
        setFilterValueJob(e.target.value);

        if (filtersEnabledJob) {
            FilterJobs();
        }
    };

    useEffect(() => {
        if (filtersEnabledJob) {
            FilterJobs();
        }
    }, [filterByJob, filterStatusJob, filterValueJob, selectedDayRange]);


    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusJob();
    }, []);

    const FilterJobs = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/search?user_transaction=${email}&findby=${filterByJob}&findfor=${filterValueJob}&est_id=${filterStatusJob}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);

            const filterJobs = response.data.RES_RESULT.filter((job) => {
                return job.status_order !== 7 && job.colle_id === 0;
            })
            setJobList(filterJobs);

        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (!isGridView) {
            setFiltersEnabledJob(false);
        } else {
            setFiltersEnabled(false);
        }
    }, [isGridView]);

    const handleCheckboxChange = (jobId) => {
        const id = String(jobId);
        setSelectedJobs(prev =>
            prev.includes(id)
                ? prev.filter(i => i !== id)
                : [...prev, id]
        );
    };

    useEffect(() => {
        const getCollective = async () => {
            try {
                const response = await axios.get(`${server_backend}/Collective/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setCollectiveList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getCollective();
    }, []);

    const openModalCollective = () => {
        setAddCollectiveModal(true);
    }
    const closeModalCollective = () => {
        setAddCollectiveModal(false);
    }

    const AsignCollectiveGroup = async (JobID, GroupID) => {
        try {
            const response = await axios.post(`${server_backend}/jobs/manual/update_collective`, {
                id: JobID,
                collective: GroupID
            }, headers);

        } catch (error) {
            return error
        }

    }

    const addJobToGroup = async () => {

        try {

            for (let group of selectedJobs) {
                await AsignCollectiveGroup(group, selectedGroup);
            }

            Swal.fire({
                icon: 'success',
                title: 'Added Successfully',
                showConfirmButton: false,
                timer: 1000
            });
            getJobs();
            setSelectedJobs([]);
            closeModalCollective();

        } catch (error) {
            console.log("Unexpected error, please check")
        }

    }

    const handleGroupChange = (e) => {
        setSelectedGroup(e.target.value);
    }

    const handleDeselect = (e) => {
        const deselectedElements = e.deselected || [];
        const deselectedIDs = deselectedElements.map(el => el.getAttribute("data-job-id"));

        setSelectedJobs(prev => prev.filter(id => !deselectedIDs.includes(id)));
    };

    const toggleShowInProcess = () => {

        setShowInProcess(prev => !prev);

    };

    useEffect(() => {
        getOrders();
    }, [showInProcess]);

    const selectoRef = useRef();

    useEffect(() => {
        const container = document.querySelector(".card-body");

        const onScroll = () => {
            if (selectoRef.current) {
                selectoRef.current.checkScroll();
            }
        };

        if (container) {
            container.addEventListener("scroll", onScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", onScroll);
            }
        };
    }, []);



    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBOrder ? (
                <OrderViews OrderID={currentOrder} getOrders={getOrders} CloseViewOrder={CloseViewOrder} />
            ) : (
                isUpdating ? (
                    <UpdateOrder onClose={CloseModalUpdate} onOrderID={currentOrder} getOrders={getOrders} />
                ) : (
                    viewBJob ? (

                        <JobLiveView JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseViewJob} />

                    ) : (
                        <div className="container-fluid card border-0">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Orders List</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Orders</a></li>
                                                <li className="breadcrumb-item active">List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header border-0">
                                            <div className="d-flex align-items-center">

                                                {/* Title */}
                                                <h5 className="card-title mb-0 flex-grow-1">All Orders</h5>

                                                <button className="btn btn-outline-secondary border-0 d-flex align-items-center" onClick={toggleView}>
                                                    <i className={isGridView ? "ri-list-check-2" : "ri-grid-fill"} style={{ fontSize: "24px", paddingRight: "4px" }}></i>
                                                </button>

                                                <div className="flex-shrink-0" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-outline-secondary" title="show orders in processes" onClick={toggleShowInProcess}
                                                    >
                                                        <i className={` ${showInProcess ? "ri-eye-off-line" : "ri-eye-fill"} me-1 align-bottom`}></i>
                                                    </button>
                                                </div>

                                               
                                                    <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                        <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                            <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                        </button>
                                                    </div>

                                              

                                                {!isGridView && (
                                                    <div className="flex-shrink-0">
                                                        <Link className="btn btn-success add-btn" to="/create-Order">
                                                            <i className="ri-add-line align-bottom me-1"></i> Generate Order
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabled}
                                                                value={filterBy}
                                                                onChange={handleFilterByChange}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="ord_ID">ID</option>
                                                                <option value="fullname">Customer name</option>
                                                                <option value="email">Email</option>
                                                                <option value="phone">Phone</option>
                                                                <option value="city">City</option>
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                id="idFilterStatus"
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterStatusChange}
                                                            >
                                                                <option value={0}>Filter status</option>
                                                                {statusQuot.map((status) => (
                                                                    <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <CustomDateRangePicker onDateChange={handleDateChange} />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterValueChange}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                        {filtersEnabledJob && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabledJob}
                                                                value={filterByJob}
                                                                onChange={handleFilterByChangeJob}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="materials_name">Alloy Type</option>
                                                                <option value="fullname">Customer</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="col-4">
                                                        <CustomDateRangePicker onDateChange={handleDateChangeJob} />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabledJob}
                                                                onChange={handleFilterValueChangeJob}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {isGridView ? (

                                            <div className="card-body" style={{minHeight: "80vh"}}>
                                                <div className="row g-3">
                                                    {currentItems.map((Orders_L) => (
                                                        <div
                                                            key={Orders_L.ord_ID}
                                                            className="col-md-6 col-lg-2"
                                                            onClick={() => {
                                                                ShowModalUpdate();
                                                                setCurrentOrder(Orders_L.ord_ID);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <div
                                                                className="card h-100 border-0 rounded-4"
                                                                style={{
                                                                    background: "linear-gradient(145deg, #ffffff, #f3f3f3)",
                                                                    boxShadow:
                                                                        "0 8px 20px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.08)",
                                                                    transition: "all 0.3s ease",
                                                                    border: "1px solid rgba(0,0,0,0.05)",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.boxShadow =
                                                                        "0 12px 28px rgba(0,0,0,0.2), 0 6px 16px rgba(0,0,0,0.1)";
                                                                    e.currentTarget.style.transform = "translateY(-6px) scale(1.02)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.boxShadow =
                                                                        "0 8px 20px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.08)";
                                                                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                                                                }}
                                                            >
                                                                <div className="card-body d-flex flex-column justify-content-between">
                                                                    <div>
                                                                        <h5
                                                                            className="card-title fw-bold mb-2"
                                                                            style={{
                                                                                color: "#1e88e5",
                                                                                fontSize: "1.2rem",
                                                                                letterSpacing: "0.5px",
                                                                            }}
                                                                        >
                                                                            #{Orders_L.ord_ID}
                                                                        </h5>
                                                                        <p className="mb-1 text-dark fw-semibold">
                                                                            <i className="ri-user-line me-1 text-primary"></i>
                                                                            {Orders_L.fullname}
                                                                        </p>
                                                                        <p className="mb-1 text-muted small">
                                                                            <i className="ri-calendar-line me-1"></i>
                                                                            {vAdminformat.FormatDate(Orders_L.date_created)}
                                                                        </p>
                                                                        <span
                                                                            className={`${Orders_L.est_ID === 7
                                                                                ? "badge badge-soft-warning text-uppercase"
                                                                                : Orders_L.est_ID === 8
                                                                                    ? "badge badge-soft-success text-uppercase"
                                                                                    : Orders_L.est_ID === 9
                                                                                        ? "badge badge-soft-secondary text-uppercase"
                                                                                        : Orders_L.est_ID === 10
                                                                                            ? "badge badge-soft-success text-uppercase"
                                                                                            : Orders_L.est_ID === 11
                                                                                                ? "badge badge-soft-danger text-uppercase"
                                                                                                : Orders_L.est_ID === 12
                                                                                                    ? "badge badge-label bg-danger"
                                                                                                    : ""
                                                                                } text-uppercase`}
                                                                        >
                                                                            {Orders_L.status_name}
                                                                        </span>
                                                                    </div>

                                                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                                                        <Link
                                                                            type="button"
                                                                            onClick={(e) => {
                                                                                ShowModalUpdate();
                                                                                setCurrentOrder(Orders_L.ord_ID);
                                                                                e.stopPropagation();
                                                                            }}
                                                                            className="btn btn-sm btn-outline-primary"

                                                                        >
                                                                            <i className="ri-pencil-fill"></i>
                                                                        </Link>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            
                                        ) : (
                                            <div className="card-body">
                                                <div
                                                    className="table-responsive table-card mb-4"
                                                    style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                                >
                                                    <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                        <thead className="table-light text-muted">
                                                            <tr>
                                                                <th className="th-hover" onClick={() => handleColumnClick("ord_ID")}>ID</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Full name</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("date_created")}>Dated created</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("city")}>User Created</th>
                                                                <th className="th-hover" onClick={() => handleColumnClick("status")}> Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="list form-check-all">
                                                            {currentItems.map((Orders_L) => (
                                                                <tr
                                                                    key={Orders_L.ord_ID}
                                                                    className="row-hover"
                                                                    onClick={() => {
                                                                        ShowModalUpdate();
                                                                        setCurrentOrder(Orders_L.ord_ID);
                                                                    }}
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 10,
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.zIndex = 20;
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.zIndex = 10;
                                                                    }}
                                                                >
                                                                    <td
                                                                        className="id"
                                                                        style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                    >
                                                                        <Link
                                                                            to="#"
                                                                            className="fw-medium link-primary"
                                                                            onClick={(e) => e.preventDefault()}
                                                                        >
                                                                            {Orders_L.ord_ID}
                                                                        </Link>
                                                                    </td>
                                                                    <td
                                                                        className="fullname"
                                                                        style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                    >
                                                                        {Orders_L.fullname}
                                                                    </td>
                                                                    <td
                                                                        className="phone"
                                                                        style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                    >
                                                                        {Orders_L.phone}
                                                                    </td>
                                                                    <td
                                                                        className="date"
                                                                        style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                    >
                                                                        {vAdminformat.FormatDate(Orders_L.date_created)}
                                                                    </td>
                                                                    <td
                                                                        className="user_created"
                                                                        style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                    >
                                                                        {Orders_L.user_created}
                                                                    </td>
                                                                    <td className="status">
                                                                        <span
                                                                            className={`${Orders_L.est_ID === 7
                                                                                ? "badge badge-soft-warning text-uppercase"
                                                                                : Orders_L.est_ID === 8
                                                                                    ? "badge badge-soft-success text-uppercase"
                                                                                    : Orders_L.est_ID === 9
                                                                                        ? "badge badge-soft-secondary text-uppercase"
                                                                                        : Orders_L.est_ID === 10
                                                                                            ? "badge badge-soft-success text-uppercase"
                                                                                            : Orders_L.est_ID === 11
                                                                                                ? "badge badge-soft-danger text-uppercase"
                                                                                                : Orders_L.est_ID === 12
                                                                                                    ? "badge badge-label bg-danger"
                                                                                                    : ""
                                                                                } text-uppercase`}
                                                                        >
                                                                            {Orders_L.status_name}
                                                                        </span>
                                                                    </td>
                                                                    <td className="due_date">
                                                                        <ul className="list-inline hstack gap-2 mb-0 fs-5">
                                                                            {/*    <li className="list-inline-item" >
                                                                                <Link className="text-danger d-inline-block remove-item-btn" onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    setCurrentOrder(Orders_L.ord_ID);
                                                                                    showViewOrder()
                                                                                }}
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top" title="View ">
                                                                                    <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                                </Link>
                                                                            </li>  */}
                                                                            <li className="list-inline-item edit">
                                                                                <Link
                                                                                    type="button"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        ShowModalUpdate();
                                                                                        setCurrentOrder(Orders_L.ord_ID);
                                                                                    }}
                                                                                    className="text-primary d-inline-block edit-item-btn"
                                                                                    title="Update"
                                                                                >
                                                                                    <i className="ri-pencil-fill fs-16"></i>
                                                                                </Link>
                                                                            </li>
                                                                            <li className="list-inline-item">
                                                                                <Link
                                                                                    className="text-danger d-inline-block remove-item-btn"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleUpdate(Orders_L.ord_ID);
                                                                                    }}
                                                                                    title="Delete"
                                                                                >
                                                                                    <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                                </Link>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>



                                                    </table>
                                                </div>
                                                <div className="row justify-content-between align-items-center">
                                                    <div className="col-auto me-3">
                                                        <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, OrderList.length)} of {OrderList.length} entries</p>
                                                    </div>
                                                    <div className="col-auto">
                                                        <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                            </li>
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                    <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="row g-0 text-center text-sm-start">
                                                    <div className="col-sm-6">
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                )
            )}

            <div className={`modal fade ${addCollectiveModal ? 'show' : ''}`}
                style={{ display: addCollectiveModal ? 'block' : 'none', backgroundColor: "#0000007a" }}
                tabIndex="-1">

                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "40%" }}>
                    <div className="modal-content shadow-lg border-0 rounded-3">
                        <div className="modal-header bg-primary text-white" style={{ minHeight: "50px" }}>
                            <button type="button" className="btn-close" onClick={closeModalCollective} aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <i className="mdi mdi-human-dolly text-primary fs-1 mb-3"></i>
                            <h5 className="fw-bold text-primary">Choose a group</h5>
                            <select id="groupSelect" className="form-select shadow-sm" onChange={handleGroupChange} value={selectedGroup}>
                                <option value="">Select a group...</option>
                                {collectiveList.map(group => (
                                    <option key={group.colle_id} value={group.colle_id}>{group.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button type="button" className="btn btn-secondary" onClick={closeModalCollective}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={addJobToGroup}>Confirm</button>
                        </div>

                    </div>
                </div>
            </div>

        </div >
    );
};

export default Orders;
